(function() {
    if (document.body.classList.contains('doofinder-active')) return;

    const inputSelector = document.querySelector('.header-search-custom #side-panel-search-input');
    const resultsBox = document.querySelector('.header-search-custom .side-panel-content');
    const headerEl = document.querySelector('header');

    // Validar que todos los elementos existan antes de agregar el listener
    if (inputSelector && resultsBox && headerEl) {
      inputSelector.addEventListener('input', () => {
        if (inputSelector.value.trim() !== '') {
          resultsBox.classList.add('results-active');
          headerEl.classList.remove('transparent--true');
        } else {
          resultsBox.classList.remove('results-active');
          headerEl.classList.add('transparent--true');
        }
      });
    }
})();

// ============================================
// CARRUSEL DE IMÁGENES DESLIZABLE EN COLECCIONES
// ============================================

(function() {
    'use strict';

    function initImageCarousel() {
        const imageLinks = document.querySelectorAll('product-card .product-featured-image-link.product-image-carousel');
        
        imageLinks.forEach(function(link) {
            if (link.hasAttribute('data-carousel-initialized')) return;
            
            // Verificar si el elemento está dentro de un carousel de sección
            const isInCarousel = link.closest('.featured-collection__inner.display-type--carousel') ||
                                link.closest('.featured-collection__inner.display-type--grid') ||
                                link.closest('.collection-grid__carousel') ||
                                link.closest('.carousel.flickity-enabled');
            
            // No inicializar el deslizamiento en carruseles de sección ni grids de colección
            if (isInCarousel) {
                return;
            }
            
            link.setAttribute('data-carousel-initialized', 'true');
            
            // Buscar imágenes dentro del wrapper de scroll
            const scrollWrapper = link.querySelector('.product-images-scroll-wrapper');
            const images = scrollWrapper ? 
                scrollWrapper.querySelectorAll('.product-primary-image, .product-secondary-image') : 
                link.querySelectorAll('.product-primary-image, .product-secondary-image');
            const progressBar = link.parentElement.querySelector('.product-image-progress');
            const progressBarInner = progressBar ? progressBar.querySelector('.product-image-progress-bar') : null;
            const totalImages = images.length;
            
            if (images.length <= 1) return; // No hacer nada si solo hay una imagen
            
            let currentIndex = 0;
            let startX = 0;
            let currentX = 0;
            let isDragging = false;
            let scrollLeft = 0;
            
            // Función para actualizar la barra de progreso
            function updateProgressBar(index) {
                if (!progressBarInner) return;
                
                const barWidth = 100 / totalImages;
                const translateX = (index * 100) / totalImages;
                
                progressBarInner.style.width = barWidth + '%';
                progressBarInner.style.transform = 'translateX(' + translateX + '%)';
            }
            
            // Obtener el elemento que realmente hace scroll (el link, no el wrapper)
            // El wrapper está dentro del link y el link es el que tiene overflow-x: auto
            
            // Función para ir a una imagen específica
            function goToImage(index) {
                if (index < 0 || index >= images.length) return;
                currentIndex = index;
                
                const imageWidth = link.offsetWidth;
                link.scrollTo({
                    left: imageWidth * index,
                    behavior: 'smooth'
                });
                
                updateProgressBar(index);
            }
            
            // Touch events para móvil - Permitir scroll nativo
            let touchStartX = 0;
            let touchStartY = 0;
            
            link.addEventListener('touchstart', function(e) {
                touchStartX = e.touches[0].clientX;
                touchStartY = e.touches[0].clientY;
            }, { passive: true });
            
            link.addEventListener('touchmove', function(e) {
                // Permitir scroll nativo del navegador
                // No prevenir el comportamiento por defecto
            }, { passive: true });
            
            link.addEventListener('touchend', function(e) {
                // Actualizar barra de progreso después del scroll
                setTimeout(function() {
                    const imageWidth = link.offsetWidth;
                    const scrollPosition = link.scrollLeft;
                    const newIndex = Math.round(scrollPosition / imageWidth);
                    
                    if (newIndex !== currentIndex && newIndex >= 0 && newIndex < images.length) {
                        currentIndex = newIndex;
                        updateProgressBar(newIndex);
                    }
                }, 100);
            }, { passive: true });
            
            // Scroll event para actualizar barra de progreso cuando se hace scroll manual
            link.addEventListener('scroll', function() {
                const imageWidth = link.offsetWidth;
                const scrollPosition = link.scrollLeft;
                const newIndex = Math.round(scrollPosition / imageWidth);
                
                if (newIndex !== currentIndex && newIndex >= 0 && newIndex < images.length) {
                    currentIndex = newIndex;
                    updateProgressBar(newIndex);
                }
            }, { passive: true });
            
            // Inicializar la barra de progreso
            updateProgressBar(0);
            
            // Prevenir el click en el link cuando se está arrastrando
            link.addEventListener('click', function(e) {
                if (isDragging) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        });
    }
    
    // Inicializar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initImageCarousel);
    } else {
        initImageCarousel();
    }
    
    // Reinicializar cuando se carguen nuevos productos (para carouseles dinámicos)
    const observer = new MutationObserver(function() {
        const newCarousels = document.querySelectorAll('product-card .product-featured-image-link.product-image-carousel:not([data-carousel-initialized])');
        if (newCarousels.length > 0) {
            initImageCarousel();
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();

// ============================================
// FIX PARA PRODUCT ADD TO CART STICKY
// ============================================

(function() {
    'use strict';
    
    // Solo ejecutar en páginas de producto
    if (!document.body.classList.contains('template-product')) {
        return;
    }
    
    // Esperar a que el DOM esté listo
    function initStickyButton() {
        const stickyButton = document.querySelector('product-add-to-cart-sticky');
        
        if (!stickyButton) {
            // Reintentar después de un breve delay si el elemento aún no existe
            setTimeout(initStickyButton, 500);
            return;
        }
        
        // Verificar que el custom element se haya inicializado correctamente
        // Si no tiene el observer configurado, intentar forzar la inicialización
        const sectionId = stickyButton.dataset.section;
        const form = document.getElementById(`product-form-${sectionId}`);
        const footer = document.getElementById('footer');
        
        // Si el formulario o el footer no existen, el observer no funcionará
        // En ese caso, usar un fallback basado en scroll
        if (!form || !footer) {
            let formPassed = false;
            const formElement = document.querySelector('product-form form, form[action*="/cart/add"]');
            
            if (formElement) {
                window.addEventListener('scroll', function() {
                    const formRect = formElement.getBoundingClientRect();
                    const scrollY = window.scrollY;
                    
                    // Si el formulario está fuera de la vista y hemos scrolleado más allá de él
                    if (formRect.bottom < 0 && scrollY > (formRect.top + formRect.height + window.scrollY)) {
                        if (!formPassed) {
                            formPassed = true;
                            if (typeof stickyButton.setStickyVisible === 'function') {
                                stickyButton.setStickyVisible(true);
                            } else {
                                stickyButton.classList.add('sticky--visible');
                            }
                        }
                    } else if (formRect.top >= 0 && formRect.top < window.innerHeight) {
                        formPassed = false;
                        if (typeof stickyButton.setStickyVisible === 'function') {
                            stickyButton.setStickyVisible(false);
                        } else {
                            stickyButton.classList.remove('sticky--visible');
                        }
                    }
                    
                    const footerRect = footer ? footer.getBoundingClientRect() : null;
                    if (footer && footerRect && footerRect.top < window.innerHeight) {
                        if (typeof stickyButton.setStickyVisible === 'function') {
                            stickyButton.setStickyVisible(false);
                        } else {
                            stickyButton.classList.remove('sticky--visible');
                        }
                    }
                }, { passive: true });
            }
        }
    }
    
    // Inicializar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStickyButton);
    } else {
        initStickyButton();
    }
    
    // También intentar después de un delay adicional para elementos que se cargan dinámicamente
    setTimeout(initStickyButton, 1000);
})();